module.exports = __webpack_public_path__ + "static/media/laidDown.c1960e68.jpg";